import client from 'shared/ApiClient';
import { getRecruitToken } from 'recruit/context/RecruitCandidateUserContext';
import { Request } from 'shared/Request';

export const recruitClient = (endpoint: string, { body, ...customConfig }: Request = {}, stringify: boolean = true) => {
    const token = getRecruitToken() || undefined;
    return client(endpoint, { token, body, ...customConfig }, stringify);
};
